export default function config(blockUIConfig){

    // Change the default overlay message
    blockUIConfig.message = 'Please stop clicking!';

    // Change the default delay to 100ms before the blocking is visible
    blockUIConfig.delay = 100;

    // Disable automatically blocking of the user interface
    blockUIConfig.autoBlock = true;

    // Change the displayed message based on the http verbs being used.
    blockUIConfig.requestFilter = function(config) {

        var message;

        switch(config.method) {
            case 'GET':
                message = 'Cargando ...';
                break;

            case 'POST':
                message = 'En proceso ...';
                break;

            case 'DELETE':
                message = 'Eliminando ...';
                break;

            case 'PUT':
                message = 'Editando ...';
                break;
        };

        return message;

    };

}




// WEBPACK FOOTER //
// ./app/js/config/blockUI.js